export default {
    resetPassword: 'Reset Password',
    title: 'We\'ll send password reset instructions to the email address associated with your account.',
    btnText: 'Reset Password',
}